<footer id="footerId" class="theme-bg  text-white">
    <div class="row p-3 m-0 w-100">
        <!-- Company Details PDF -->
        <div class="col-lg-4 alignment-padding">
            <a class="company-details">{{'footer_company_info' | translate}}</a>
            <!-- Financial Statements -->
            <div class="d-flex">
                <a class="company-years" href="assets/pdf/Χρηματοοικονομικές-Καταστάσεις-2020.pdf"
                    target="_blank">2020</a>
                <div class="space-div"></div>
                <a class="company-years" href="assets/pdf/Χρηματοοικονομικές-Καταστάσεις-2021.pdf"
                    target="_blank">2021</a>
                <div class="space-div"></div>
                <a class="company-years" href="assets/pdf/Χρηματοοικονομικές-Καταστάσεις-2022.pdf"
                    target="_blank">2022</a>
                <div class="space-div"></div>
                <a class="company-years" href="assets/pdf/Χρηματοοικονομικές-Καταστάσεις-2023.pdf"
                    target="_blank">2023</a>
                <div class="space-div"></div>
                <a class="company-years" href="assets/pdf/Χρηματοοικονομικές-Καταστάσεις-2024.pdf"
                    target="_blank">2024</a>
            </div>
        </div>
        <!-- Services And Number -->
        <div class="col-lg-3 alignment-padding">
            <p class="service-number-word">{{'footer_service_number' | translate}}</p>
            <p class="service-number-numb">18198</p>
        </div>
        <div class="col-lg-5 text-end alignment-padding">
            <!-- Copyright -->
            <h4>Copyright © 2021 ElpeFuture</h4>
            <div>
                <!-- Privacy Policy PDF -->
                <a class="terms-more" href="{{'footer_html_privacy_policy' | translate}}"
                    target="_blank">{{'footer_privacy' |
                    translate}} | </a>
                <!-- Terms Of Use PDF -->
                <a class="terms-more" href="{{'footer_pdf_terms' | translate}}" target="_blank"> {{'footer_terms' |
                    translate}}
                </a>
            </div>
        </div>
    </div>
</footer>